import ShareUsersPopup from './ShareUsersPopup.connect';
export default ShareUsersPopup;
